import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

// renders a dish name, extras and special note
// with a tick box that state can be used by parent for things 
export default function TickBoxDish ({dishInfo, handleChange, defaultChecked, checked}) {

  let dishLabel = dishInfo.name;

  if (dishInfo.quantity > 1) {
    dishLabel = dishInfo.quantity + "x " + dishInfo.name;
  }

  
  //extras list
  let ext = [];
  for (const [k, value] of Object.entries(dishInfo.extras)) {
    ext.push(" " + value.quantity + "x " + value.name);
  };
  if (ext.length > 0) {
    ext = "Extras: " + ext;
  }

  //special notes
  let note = dishInfo.customerInstructions;
  if (note != "") {
    note = "Instructions: " + note;
  }


  return ( 
    <FormGroup>
      <FormControlLabel label={dishLabel} control={
        <Checkbox sx={{width: 1/10, p: 2}}
        disableRipple
        onChange={handleChange}
        defaultChecked={defaultChecked}
        checked={checked}/>
      }
      />
      <Typography variant="h6" sx={{fontSize: '16px', pl: 1, flexShrink: 1}} >
        {ext}
      </Typography>
      <Typography variant="h6" sx={{fontSize: '16px', pl: 1, flexShrink: 1}} >
        {note}
      </Typography>
    </FormGroup>
  )
}